(() => {
const observers = new WeakMap();
const init = root => {
  if (!root || root.dataset.ready) return;
  root.dataset.ready = 'true';

  const menu = root.querySelector('[data-fa-menu]');
  const panel = root.querySelector('[data-fa-panel]');
  menu?.addEventListener('click', () => {
    const open = menu.getAttribute('aria-expanded') === 'true';
    menu.setAttribute('aria-expanded', String(!open));
    panel.hidden = open;
  });

  const body = root.querySelector('[data-fa-article-body]');
  const headings = body ? [...body.querySelectorAll('h2, h3')] : [];
  const outline = root.querySelector('[data-fa-outline]');
  const list = root.querySelector('[data-fa-toc-list]');
  if (outline && list && headings.length) {
    const used = new Set();
    const hasH2 = headings.some(heading => heading.tagName === 'H2');
    const entries = headings.map(heading => {
      const title = heading.textContent.trim();
      const base = heading.id || title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'section';
      let id = base, suffix = 2;
      while (used.has(id) || (document.getElementById(id) && document.getElementById(id) !== heading)) id = `${base}-${suffix++}`;
      used.add(id);
      heading.id = id;
      const item = document.createElement('li');
      if (hasH2 && heading.tagName === 'H3') item.className = 'fa-outline-subheading';
      const link = document.createElement('a');
      link.href = `#${encodeURIComponent(id)}`;
      link.textContent = title.replace(/^\d+[.)]\s*/, '');
      item.append(link);
      list.append(item);
      return {heading, link};
    });
    outline.hidden = false;
    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(items => {
        const visible = items.filter(item => item.isIntersecting).sort((a,b) => a.boundingClientRect.top - b.boundingClientRect.top)[0];
        if (!visible) return;
        entries.forEach(entry => entry.link.setAttribute('aria-current', String(entry.heading === visible.target)));
      }, {rootMargin: '-10% 0px -65% 0px'});
      entries.forEach(entry => observer.observe(entry.heading));
      observers.set(root, observer);
    }
  }

  const shareData = { title: document.title, text: root.querySelector('h1')?.textContent || document.title, url: location.href.split('#')[0] };
  const copyLink = async (url = shareData.url) => {
    const status = root.querySelector('[data-fa-share-status]');
    try {
      await navigator.clipboard.writeText(url);
      if (status) { status.textContent = 'Link copied.'; setTimeout(() => status.textContent = '', 1800); }
    } catch (_) {
      location.href = `mailto:?subject=${encodeURIComponent(shareData.title)}&body=${encodeURIComponent(url)}`;
    }
  };
  root.querySelectorAll('[data-fa-share]').forEach(button => button.addEventListener('click', async () => {
    if (navigator.share && matchMedia('(max-width: 899px)').matches) { try { await navigator.share(shareData); } catch (_) {} }
    else copyLink();
  }));
  const shareTrigger = root.querySelector('[data-fa-share-menu-trigger]');
  const shareMenu = root.querySelector('[data-fa-share-menu]');
  shareTrigger?.addEventListener('click', async () => {
    if (navigator.share && matchMedia('(max-width: 899px)').matches) { try { await navigator.share(shareData); } catch (_) {} return; }
    shareMenu.hidden = !shareMenu.hidden;
  });
  root.querySelector('[data-fa-copy-link]')?.addEventListener('click', () => { copyLink(); shareMenu.hidden = true; });
  root.querySelectorAll('[data-fa-copy-comment]').forEach(button => button.addEventListener('click', () => copyLink(`${shareData.url}${button.dataset.faCopyComment}`)));

  const appreciate = root.querySelector('[data-fa-appreciate]');
  appreciate?.addEventListener('click', async () => {
    if (appreciate.disabled) return;
    appreciate.disabled = true;
    try {
      const response = await fetch(appreciate.dataset.endpoint, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ article_id: appreciate.dataset.articleId, action: 'toggle' }) });
      if (!response.ok) throw new Error('Unable to update appreciation');
      const data = await response.json();
      appreciate.setAttribute('aria-pressed', String(Boolean(data.appreciated)));
      const count = appreciate.querySelector('[data-fa-appreciate-count]');
      if (count && Number.isFinite(data.count)) { count.hidden = false; count.textContent = data.count; }
    } catch (_) {
      appreciate.title = 'Appreciation is temporarily unavailable.';
    } finally { appreciate.disabled = false; }
  });

  const dialog = root.querySelector('[data-fa-search-dialog]');
  root.querySelectorAll('[data-fa-search]').forEach(button => button.addEventListener('click', () => { dialog.showModal(); setTimeout(() => dialog.querySelector('input').focus(), 30); }));
  root.querySelector('[data-fa-search-close]')?.addEventListener('click', () => dialog.close());
  const index = JSON.parse(root.querySelector('[data-fa-index]')?.textContent || '[]');
  const form = root.querySelector('[data-fa-search-form]');
  const results = root.querySelector('[data-fa-results]');
  const render = query => {
    const terms = query.toLowerCase().trim().split(/\s+/).filter(Boolean);
    if (!terms.length) { results.innerHTML = ''; return; }
    const ranked = index.map(item => {
      const title=item.title.toLowerCase(), tags=item.tags.toLowerCase(), excerpt=item.excerpt.toLowerCase(), articleBody=item.body.toLowerCase();
      let score=0;
      terms.forEach(term => { if(title===term)score+=40; if(title.includes(term))score+=18; if(tags.includes(term))score+=12; if(excerpt.includes(term))score+=6; if(articleBody.includes(term))score+=2; });
      return {...item,score};
    }).filter(item=>item.score>0).sort((a,b)=>b.score-a.score).slice(0,8);
    results.innerHTML = ranked.length ? ranked.map(item=>`<a class="fa-result" href="${item.url}">${item.image?`<img src="${item.image}" alt="">`:''}<span><strong>${item.title}</strong><span>${item.excerpt}</span></span></a>`).join('') : '<p>No conversations found.</p>';
  };
  form?.addEventListener('submit', event => { event.preventDefault(); render(form.querySelector('input').value); });
  form?.querySelector('input')?.addEventListener('input', event => render(event.target.value));
};
const initAll = scope => {
  if (scope.matches?.('[data-foundations-article]')) init(scope);
  scope.querySelectorAll('[data-foundations-article]').forEach(init);
};
initAll(document);
document.addEventListener('shopify:section:load', event => initAll(event.target));
document.addEventListener('shopify:section:unload', event => {
  event.target.querySelectorAll('[data-foundations-article]').forEach(root => observers.get(root)?.disconnect());
});
})();
